<template>
  <span>
  <a v-if="allowed" class="link" @click.stop="onClick(id)">
    <slot />
  </a>
  <slot v-else />
  </span>
</template>

<script>
import links from "../mixins/links";

export default {
  name: 'EntityLink',
  mixins: [links],
  data() {
    return {
      sections: {
        advertisingBanner: 'advertisingBanners',
        brand: 'brands',
        businessModel: 'businessModels',
        channel: 'channels',
        channelPackage: 'packages',
        device: 'devices',
        deviceChannelGroup: 'channelGroups',
        deviceProfile: 'deviceProfiles',
        deviceType: 'deviceTypes',
        message: 'messages',
        operator: 'operators',
        protocol: 'protocols',
        service: 'services',
        subscriber: 'subscribers',
        subscriberProfile: 'subscribers',
        subscriberChannelGroup: 'channelGroups',
        subscriberDevices: 'subscribers',
        thematicGroup: 'thematicGroups',
        vodProvider: 'vod',
        vodVideo: 'vod',
      },
      methods: {
        advertisingBanner: 'showAdvertisingBannerDetail',
        brand: 'showBrandDetail',
        businessModel: 'showBusinessModelDetail',
        channel: 'showChannelDetail',
        channelPackage: 'showChannelPackageDetail',
        device: 'showDeviceDetail',
        deviceChannelGroup: 'showDeviceChannelGroupDetail',
        deviceProfile: 'showDeviceProfileDetail',
        deviceType: 'showDeviceTypeDetail',
        message: 'showMessageDetail',
        operator: 'showOperatorDetail',
        protocol: 'showProtocolDetail',
        service: 'showServiceDetail',
        subscriber: 'showSubscriberDetail',
        subscriberProfile: 'showSubscriberProfileDetail',
        subscriberChannelGroup: 'showSubscriberChannelGroupDetail',
        subscriberDevices: 'showSubscriberDevicesDetail',
        thematicGroup: 'showThematicGroupDetail',
        vodProvider: 'showVodProviderDetail',
        vodVideo: 'showVodVideoDetail',
      }
    }
  },
  props: {
    id: [String, Number],
    type: String,
    params: Object,
  },
  methods: {
    onClick(id) {
      this[this.methods[this.type]](id)
    }
  },
  computed: {
    allowed() {
      return this.$_loggedUser_action_allowed(this.sections[this.type], 'read')
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/common/EntityLink.vue